import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../Box/index.js';

const StyledPaginationButton = styled(Box).withConfig({
  displayName: "styles__StyledPaginationButton",
  componentId: "sc-12ovjcu-0"
})(["background-color:initial;border:none;border-radius:", ";color:", ";cursor:pointer;outline:none;height:40px;width:40px;transition:", ";transition-property:color,box-shadow,background-color;padding:initial;&:disabled{color:", ";cursor:not-allowed;box-shadow:none;}", ""], themeGet('radii.radiusDefault'), themeGet('colors.slate500'), themeGet('transitions.fast'), themeGet('colors.slate200'), _ref => {
  let {
    selected
  } = _ref;
  return selected ? css(["background-color:", ";color:", ";font-family:", ";"], themeGet('colors.slate500'), themeGet('colors.background'), themeGet('fonts.semi')) : css(["&:hover:not(:disabled){background-color:", ";}"], themeGet('colors.slate100'));
});

export { StyledPaginationButton };
